<template>
  <div>
    <PageAllow controller="ShopSales" action="index" />
    <Breadcrumbs :items="items" />

    <v-sheet class="overflow-y-scroll fill-content-height">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4">
          <v-row dense align="center" class="pa-1">
            <SearcherOrderDate
              v-model="options"
              show-radio
              show-radio-actual
              show-radio-expect
              removeIcon
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-divider vertical />
            <v-btn
              class="caption font-weight-bold grey--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              small
              text
              @click.stop="$store.commit('toggleSearchPanel')"
            >
              {{ $t("Search.pro") }}
              <v-icon small class="ps-1">{{
                $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
              }}</v-icon>
            </v-btn>
            <v-btn
              v-show="shopSales && shopSales.length"
              class="caption font-weight-bold grey--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              small
              text
              @click.stop="$store.commit('toggleBarEcharts')"
            >
              {{
                $store.state.showBarEchartsPanel
                  ? $t("App.hideSparkline")
                  : $t("App.showSparkline")
              }}
              <v-icon small class="ps-1">{{
                $store.state.showBarEchartsPanel
                  ? "fa-angle-up"
                  : "fa-angle-down"
              }}</v-icon>
            </v-btn>
            <v-spacer />
            <v-btn
              small
              color="print"
              dark
              @click.stop="exportExcel()"
              class="ms-1"
            >
              <v-icon x-small class="pe-1">fa-file-excel</v-icon>
              {{ $t("Export.excel", [$t("Nav.shopSales")]) }}
            </v-btn>
            <v-btn
              small
              color="print"
              dark
              @click.stop="exportExcelJX()"
              class="ms-1"
              v-if="
                $permission.permissionAllow(
                  'ShopSales',
                  'shopOrderCountJiangXiExport'
                )
              "
            >
              <v-icon x-small class="pe-1">fa-file-excel</v-icon>
              {{ $t("ShopSales.exportExcelJX") }}
            </v-btn>
            <!-- 三联定制导出 -->
            <v-btn
              small
              color="print"
              dark
              @click.stop="exportExcelSL()"
              class="ms-1"
              v-if="
                $permission.permissionAllow(
                  'ShopSales',
                  'shopOrderCountSanLianExport'
                )
              "
            >
              <v-icon x-small class="pe-1">fa-file-excel</v-icon>
              {{ $t("ShopSales.exportExcelJX") }}
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <v-expansion-panels
        v-model="$store.getters.panels"
        multiple
        flat
        accordion
      >
        <v-expansion-panel class="transparent-background-color">
          <v-expansion-panel-content>
            <v-row dense align="center">
              <v-col cols="12" sm="6" md="4">
                <SearcherAlliances v-model="alliancesSelected" />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherShops
                  v-model="shopsSelected"
                  :districtCodes="districtCodes"
                  :districtID="districtID"
                  :allianceBusinessIds="options.alliance_business_ids"
                />
              </v-col>
              <!-- 分组 -->
              <v-col
                cols="12"
                sm="6"
                md="4"
                v-if="
                  settings && settings.report_hide_search_district_tree == 2
                "
              >
                <SearcherDistrictsWithDescendants
                  v-model="DistrictsSelected"
                  :label="
                    $t('shopDailyReports.shopDistricts', [$consts.shopName()])
                  "
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherOrderOriginFlgs v-model="options.origin_flgs" />
              </v-col>
              <v-col cols="12" sm="12" md="8">
                <SearcherOrderStatus v-model="options.status" />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherCancelFlgs v-model="options.cancel_flgs" />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- 
        <v-expansion-panel
          v-show="sparklineValues.length > 1"
          class="transparent-background-color"
        >
          <v-expansion-panel-content>
            <BarSparkline :labels="sparklineLabels" :values="sparklineValues" />
          </v-expansion-panel-content>
        </v-expansion-panel> -->
        <v-expansion-panel
          v-show="sparklineValues.length"
          class="transparent-background-color"
        >
          <v-expansion-panel-content>
            <BarEcharts :labels="sparklineLabels" :values="sparklineValues" />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="shopSales"
          :page.sync="current_page"
          :loading="loading"
          multi-sort
          class="elevation-1 px-4 pt-1"
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:body.prepend>
            <tr class="d-none d-sm-table-row">
              <td :colspan="settings && settings.report_hide_search_district_tree == 1 ? 1 : 3">
                <v-btn
                  v-if="settings && settings.report_hide_search_district_tree == 1"
                  small
                  outlined
                  color="info"
                  class="px-2 me-2"
                  :disabled="!districtID"
                  @click.stop="$emit('to-parent-district')"
                >
                  <v-icon x-small class="pe-1">fa-reply</v-icon>
                  {{ $t("District.return") }}
                </v-btn>
                <span>{{ $t("TableSum") }}</span>
              </td>
              <td :align="$vuetify.rtl ? 'left' : 'right'">
                <span
                  >{{ $t("Global.money") }}
                  {{ shopSalesTotalOrderPrice | formatMoney }}</span
                >
              </td>
              <td :align="$vuetify.rtl ? 'left' : 'right'">
                <span>{{ shopSalesTotalCount | formatNoDot }}</span>
              </td>
              <td :align="$vuetify.rtl ? 'left' : 'right'">
                <span>
                  {{ $t("Global.money") }}
                  {{
                    (shopSalesTotalOrderPrice / shopSalesTotalCount)
                      | formatMoney
                  }}
                </span>
              </td>
              <td></td>
            </tr>
            <tr class="d-table-row d-sm-none">
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{ $t("TableSum") }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  <v-btn
                    v-if="settings && settings.report_hide_search_district_tree == 1"
                    small
                    outlined
                    color="info"
                    class="px-2"
                    :disabled="!districtID"
                    @click.stop="$emit('to-parent-district')"
                  >
                    <v-icon x-small class="pe-1">fa-reply</v-icon>
                    {{ $t("District.return") }}
                  </v-btn>
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{ $t("ShopSales.TableHeaders.orderPrice") }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ $t("Global.money") }}
                  {{ shopSalesTotalOrderPrice | formatMoney }}
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{ $t("ShopSales.TableHeaders.totalCount") }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ shopSalesTotalCount | formatNoDot }}
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header">
                  {{ $t("ShopSales.TableHeaders.averagePrice") }}
                </div>
                <div class="v-data-table__mobile-row__cell">
                  {{ $t("Global.money") }}
                  {{
                    (shopSalesTotalOrderPrice / shopSalesTotalCount)
                      | formatMoney
                  }}
                </div>
              </td>
            </tr>
          </template>

          <template v-slot:header.title="{ header }">
            <v-icon x-small>fa-map-marked-alt</v-icon>
            {{ header.text }}
            <v-icon x-small>fa-store</v-icon>
          </template>
          <template v-slot:item.title="{ item }">
            <span
              :class="!item.shop_name ? 'info--text' : ''"
              @click.stop="
                if (!item.shop_name) $emit('change-district', item.district);
              "
            >
              <v-icon :color="!item.shop_name ? 'info' : ''" x-small>{{
                typeof item.shop_name == "undefined"
                  ? "fa-map-marked-alt"
                  : "fa-store"
              }}</v-icon>
              {{
                typeof item.shop_name == "undefined"
                  ? item.district.name
                  : item.shop_name
              }}
              <v-icon
                :color="!item.shop_name ? 'info' : ''"
                v-if="!item.shop_name"
                x-small
                >fa-angle-double-right</v-icon
              >
            </span>
          </template>
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <template v-slot:item.total_order_price="{ item }"
            >{{ $t("Global.money") }}
            {{ item.total_order_price | formatMoney }}</template
          >
          <template v-slot:item.total_sum="{ item }">{{
            item.total_count | formatNoDot
          }}</template>
          <template v-slot:item.average_price="{ item }"
            >{{ $t("Global.money") }}
            {{
              (item.total_order_price / item.total_count) | formatMoney
            }}</template
          >
          <template v-slot:item.actions="{ item }">
            <v-btn
              v-if="item.shop_name"
              small
              outlined
              color="info"
              class="px-2 me-2"
              @click.stop="$router.push('/shop-sales/' + item.shop_id)"
            >
              <v-icon x-small class="pe-1">fa-align-left</v-icon>
              {{ $t("Opt.details") }}
            </v-btn>
          </template>
        </v-data-table>
      </div>
    </v-sheet>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
// import BarSparkline from "@/components/plugins/BarSparkline";
import SearcherOrderDate from "@/components/plugins/SearcherOrderDate";
import SearcherAlliances from "@/components/plugins/SearcherAlliances";
import SearcherShops from "@/components/plugins/SearcherShops";
import SearcherOrderStatus from "@/components/plugins/SearcherOrderStatus";
import SearcherOrderOriginFlgs from "@/components/plugins/SearcherOrderOriginFlgs";
import ShopSales from "@/api/shop_sales";
import SearcherCancelFlgs from "@/components/plugins/SearcherCancelFlgs";
import BarEcharts from "@/components/plugins/BarEcharts";
import SearcherDistrictsWithDescendants from "@/components/plugins/SearcherDistrictsWithDescendants";

const defaultOptions = {
  orderDatetimeRadios: "radio-created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  actual_time_from: "",
  actual_time_to: "",
  expect_time_from: "",
  expect_time_to: "",
  alliance_business_ids: [],
  shop_ids: [],
  status: [1, 2, 3, 4, 5, 6],
  origin_flgs: [],
  sortBy: [],
  sortDesc: [],
  cancel_flgs: [0],
  district_ids: [],
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    // BarSparkline,
    SearcherOrderDate,
    SearcherAlliances,
    SearcherShops,
    SearcherOrderStatus,
    SearcherOrderOriginFlgs,
    SearcherCancelFlgs,
    BarEcharts,
    SearcherDistrictsWithDescendants,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.shopSales"),
        disabled: true,
        href: "/shop-sales",
      },
    ],
    headers() {
      var headers = []
      if (this.settings &&
        this.settings.report_hide_search_district_tree == 1) {
        headers.push(
          {
            text: i18n.t("ShopSales.TableHeaders.title"),
            align: "start",
            sortable: false,
            value: "title",
          },
        )
      } else if (
        this.settings &&
        this.settings.report_hide_search_district_tree == 2
      ) {
        headers.push(
          {
            text: i18n.t("ShopSales.TableHeaders.shop_code", [
              this.$consts.shopName(),
            ]),
            align: "start",
            sortable: false,
            value: "shop_code",
          },
          {
            text: i18n.t("ShopSales.TableHeaders.shop_name", [
              this.$consts.shopName(),
            ]),
            align: "end",
            sortable: false,
            value: "shop_name",
          },
          {
            text: i18n.t("ShopSales.TableHeaders.shopDistrict", [
              this.$consts.shopName(),
            ]),
            align: "end",
            sortable: false,
            value: "district_name",
          },
        )
      }
      headers.push(
        {
          text: i18n.t("ShopSales.TableHeaders.orderPrice"),
          align: "end",
          sortable: false,
          value: "total_order_price",
        },
        {
          text: i18n.t("ShopSales.TableHeaders.totalCount"),
          align: "end",
          sortable: false,
          value: "total_count",
        },
        {
          text: i18n.t("ShopSales.TableHeaders.averagePrice"),
          align: "end",
          sortable: false,
          value: "average_price",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        },)
      return headers;
    },
    sparklineLabels() {
      return this.shopSales.map((shopSale) => {
        return shopSale.shop_name ? shopSale.shop_name : shopSale.district.name;
      });
    },
    sparklineValues() {
      return this.shopSales.map((shopSale) => {
        return parseFloat(shopSale.total_order_price);
      });
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "districtID", "settings"]),
  },

  mounted() {
    this.$store.commit(
      "searchDistrict",
      this.settings && this.settings.report_hide_search_district_tree == 1
        ? true
        : false
    );
    this.$commonUtils
      .loadOptions("shop-sales", [
        "alliancesSelected",
        "shopsSelected",
        "DistrictsSelected",
      ])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
            this.datetimeRage = Object.assign({}, this.datetimeRage, {
              orderDatetimeRadios: this.options.orderDatetimeRadios,
              created_time_from: this.options.created_time_from,
              created_time_to: this.options.created_time_to,
              actual_time_from: this.options.actual_time_from,
              actual_time_to: this.options.actual_time_to,
              expect_time_from: this.options.expect_time_from,
              expect_time_to: this.options.expect_time_to,
            });
            this.options.page = 1;
          } else this.resetSearch();
          if (this.$route.query && this.$route.query.created_date) {
            this.options.orderDatetimeRadios = "radio-created";
            this.options.created_time_from =
              this.$route.query.created_date + " 00:00:00";
            this.options.created_time_to =
              this.$route.query.created_date + " 23:59:59 ";
            this.$router.replace("/shop-sales");
          }
          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "alliancesSelected":
                this.alliancesSelected = selected.value;
                break;
              case "shopsSelected":
                this.shopsSelected = selected.value;
                break;
              case "DistrictsSelected":
                this.DistrictsSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },

  data: () => ({
    alliancesSelected: [],
    shopsSelected: [],
    options: JSON.parse(JSON.stringify(defaultOptions)),
    current_page: 1,
    shopSales: [],
    shopSalesTotalCount: 0,
    shopSalesTotalOrderPrice: 0,
    DistrictsSelected: [],
    districtCodes: [],
  }),

  methods: {
    resetSearch() {
      this.alliancesSelected = [];
      this.shopsSelected = [];
      this.DistrictsSelected = [];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    onSearch() {
      this.getShopSalesFromAPI();
    },
    getShopSalesFromAPI() {
      var options = JSON.parse(JSON.stringify(this.options));
      if (
        this.settings &&
        this.settings.report_hide_search_district_tree == 1
      ) {
        options = Object.assign(options, {
          district_id: this.districtID,
        });
      }
      ShopSales.fetch(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.shopSales = response.data.districts_shop_sales;
            this.shopSalesTotalCount =
              response.data.districts_shop_sales_total_count;
            this.shopSalesTotalOrderPrice =
              response.data.districts_shop_sales_total_order_price;
            this.current_page = 1; //这个接口不做后台分页，因此每次获取后切换回第一页
          }
        }.bind(this)
      );
    },
    exportExcel() {
      var options = JSON.parse(JSON.stringify(this.options));
      if (
        this.settings &&
        this.settings.report_hide_search_district_tree == 1
      ) {
        options = Object.assign(options, {
          district_id: this.districtID,
        });
      }
      ShopSales.exports(options);
    },
    exportExcelJX() {
      var options = JSON.parse(JSON.stringify(this.options));
      if (
        this.settings &&
        this.settings.report_hide_search_district_tree == 1
      ) {
        options = Object.assign(options, {
          district_id: this.districtID,
        });
      }
      ShopSales.exportsJX(options);
    },
    exportExcelSL() {
      var options = JSON.parse(JSON.stringify(this.options));
      if (
        this.settings &&
        this.settings.report_hide_search_district_tree == 1
      ) {
        options = Object.assign(options, {
          district_id: this.districtID,
        });
      }
      ShopSales.exportsSL(options);
    },
  },

  watch: {
    $route() {
      if (this.$route.query && this.$route.query.created_date) {
        this.options.orderDatetimeRadios = "radio-created";
        this.options.created_time_from =
          this.$route.query.created_date + " 00:00:00";
        this.options.created_time_to =
          this.$route.query.created_date + " 23:59:59 ";
        this.$router.replace("/shop-sales");
      }
    },
    districtID: {
      handler() {
        this.getShopSalesFromAPI();
      },
    },
    alliancesSelected: {
      handler() {
        this.options.alliance_business_ids = this.alliancesSelected.map(
          (alliance) => {
            return alliance.id;
          }
        );
        sessionStorage.setItem(
          "shop-sales-alliancesSelected",
          JSON.stringify(this.alliancesSelected)
        );
      },
    },
    shopsSelected: {
      handler() {
        this.options.shop_ids = this.shopsSelected.map((shop) => {
          return shop.id;
        });
        sessionStorage.setItem(
          "shop-sales-shopsSelected",
          JSON.stringify(this.shopsSelected)
        );
      },
    },
    DistrictsSelected: {
      handler() {
        if (this.settings &&
          this.settings.report_hide_search_district_tree == 2)
        { 
          this.options.district_ids = this.DistrictsSelected
            ? this.DistrictsSelected.map((e) => {
              return e.id;
            })
            : [];
          this.districtCodes = this.DistrictsSelected
            ? this.DistrictsSelected.map((e) => {
              return e.code;
            })
            : [];
          sessionStorage.setItem(
            "shop-sales-DistrictsSelected",
            JSON.stringify(this.DistrictsSelected)
          );
        }
      },
    },
    options: {
      // immediate: true, //为避免覆盖session里保存的options，不能启用immediate
      deep: true,
      handler() {
        this.getShopSalesFromAPI();
        sessionStorage.setItem(
          "shop-sales-options",
          JSON.stringify(this.options)
        );
      },
    },
    settings: {
      handler() {
        this.$store.commit(
          "searchDistrict",
          this.settings && this.settings.report_hide_search_district_tree == 1
            ? true
            : false
        );
      },
    },
  },

  beforeDestroy() {
    this.$store.dispatch("threadLoadingStopAll");
  },
};
</script>